/**
 * Note: I don't think this will need to be translated (language selectors usually spell entries in their respective languages)
 */
export const LanguageLabels = {
  "en-GB": "English (UK)",
  "es-MX": "Spanish (Mexico)",
  "fr-CA": "French (Canada)",
  "test": "Test (Developer)"
};
